
// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { useAuth } from "../context/AuthContext";

// const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
//   const { isAuthenticated } = useAuth();
//   const permissions = useSelector((state) => state.auth.permissions);

//   if (!isAuthenticated) return <Navigate to="/" replace />;

//   // Return user's first allowed route based on permissions
//   const getDefaultRoute = () => {
//     if (permissions.includes("view_dashboard")) return "/dashboard";
//      if (permissions.includes("view_park_dashboard")) return "/dashboard/park-dashboard";



//     return "/dashboard"; // final fallback
//   };

//   // Check permission
//   const hasAccess = requiredPermissions.every((perm) =>
//     permissions.includes(perm)
//   );

//   // If no access → redirect to first allowed page
//   if (requiredPermissions.length > 0 && !hasAccess) {
//     return <Navigate to={getDefaultRoute()} replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;

import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const { isAuthenticated } = useAuth();
  const permissions = useSelector((state) => state.auth.permissions);
  const permissionsLoaded = useSelector(
    (state) => state.auth.permissionsLoaded
  );

  if (!isAuthenticated) return <Navigate to="/" replace />;

  if (!permissionsLoaded) {
    return (
      <div style={loaderBackdropStyle}>
        <div style={loaderContainerStyle}>
          <div style={outerRingStyle} />
          <div style={middleRingStyle} />
          <div style={innerDotStyle} />
        </div>
        {/* No text – spinner only */}
        <style>{`
          @keyframes spin-clockwise {
            to { transform: rotate(360deg); }
          }
          @keyframes spin-counter {
            to { transform: rotate(-360deg); }
          }
          @keyframes pulse-opacity {
            0%, 100% { opacity: 0.6; }
            50% { opacity: 1; }
          }
        `}</style>
      </div>
    );
  }

  const getDefaultRoute = () => {
    if (permissions.includes("view_dashboard")) return "/dashboard";
    if (permissions.includes("view_park_dashboard"))
      return "/dashboard/park-dashboard";
    return "/dashboard";
  };

  const hasAccess = requiredPermissions.every((perm) =>
    permissions.includes(perm)
  );

  if (requiredPermissions.length > 0 && !hasAccess) {
    return <Navigate to={getDefaultRoute()} replace />;
  }

  return children;
};

// Styles unchanged
const loaderBackdropStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  backgroundColor: "#ffffff",
};

const loaderContainerStyle = {
  position: "relative",
  width: 80,
  height: 80,
};

const outerRingStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  border: "4px solid transparent",
  borderTopColor: "#06b6d4",
  borderRightColor: "#3b82f6",
  animation: "spin-clockwise 1.2s linear infinite",
};

const middleRingStyle = {
  position: "absolute",
  top: 12,
  left: 12,
  width: 56,
  height: 56,
  borderRadius: "50%",
  border: "3px solid transparent",
  borderBottomColor: "#8b5cf6",
  borderLeftColor: "#06b6d4",
  animation: "spin-counter 0.9s linear infinite",
};

const innerDotStyle = {
  position: "absolute",
  top: 28,
  left: 28,
  width: 24,
  height: 24,
  borderRadius: "50%",
  backgroundColor: "#06b6d4",
  opacity: 0.7,
  animation: "pulse-opacity 1.5s ease-in-out infinite",
};

export default ProtectedRoute;